import { ConnectionLayout } from 'components/login/ConnectionLayout';
import React from 'react';

import { PrimaryButtonV2 } from '@fragment/ui/src/components/Button/PrimaryButtonV2/PrimaryButtonV2';
import { SecondaryButtonV2 } from '@fragment/ui/src/components/Button/SecondaryButtonV2/SecondaryButtonV2';

export const GlobalApiAuthenticationFailed = () => (
  <ConnectionLayout title="Failed to authenticate user">
    <div className="space-y-f4">
      <p>
        This is most likely our fault. If the problem persists, please contact{' '}
        <a
          href="mailto:help@fragment.dev"
          className="hover:cursor-pointer decoration-main-500 hover:decoration-main underline transition-all duration-150 ease-in-out"
        >
          support
        </a>
        .
      </p>
    </div>
  </ConnectionLayout>
);

export const PodApiAuthenticationFailed = () => {
  const location = window.location.host;
  const message = location.includes('localhost') ? (
    <p className="text-orange">
      Hey Friend - If you&apos;re in development mode, this issue may occur due
      to the use of an incognito browser. Authentication could fail due to third
      party cookies being blocked.
    </p>
  ) : (
    <div />
  );
  return (
    <ConnectionLayout title="Failed to authenticate workspace">
      <div className="space-y-f4">
        <p>
          This is most likely our fault. Try refreshing or returning to the
          dashboard to choose another workspace. If the problem persists, please
          contact{' '}
          <a
            href="mailto:help@fragment.dev"
            className="hover:cursor-pointer decoration-main-500 hover:decoration-main underline transition-all duration-150 ease-in-out"
          >
            support
          </a>
          .
        </p>
        {message}
        <div className="flex flex-col items-start gap-f1">
          <PrimaryButtonV2
            className="px-[1ch] py-fhalf"
            onClick={() => window.location.reload()}
          >
            Refresh
          </PrimaryButtonV2>
          <SecondaryButtonV2
            className="px-[1ch] py-fhalf"
            onClick={() => window.location.assign('/')}
          >
            Back to Dashboard
          </SecondaryButtonV2>
        </div>
      </div>
    </ConnectionLayout>
  );
};
